import { render, staticRenderFns } from "./AddConnection.vue?vue&type=template&id=5b40f317&scoped=true&"
import script from "./AddConnection.vue?vue&type=script&lang=js&"
export * from "./AddConnection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b40f317",
  null
  
)

export default component.exports